import { ISeatingChartReportsByAvailability } from 'store/seatingChart/types';

export const formatReportsByAvailability = reports => {
  const selectableByCategoryKey = reports['selectable'].byCategoryKey;
  const notSelectableByCategoryKey = reports['not_selectable'].byCategoryKey;
  const result: ISeatingChartReportsByAvailability = [];

  for (const categoryKey in selectableByCategoryKey) {
    result.push({
      categoryKey,
      available: selectableByCategoryKey[categoryKey],
      total: notSelectableByCategoryKey[categoryKey],
    });
  }

  return result;
};
